import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as theme from '../theme'

/**
 * get css sizes from size props
 * medium as default
 *
 * @param string
 * @return {}
 */
const getButtonSizes = size => {
   switch (size) {
      case 'small':
         return {
            fontSize: theme.fontSize.s,
            paddingTop: theme.spacing.sm,
            paddingSides: theme.spacing.m
         }
      case 'medium':
         return {
            fontSize: theme.fontSize.sm,
            paddingTop: theme.spacing.m,
            paddingSides: theme.spacing.l
         }
      case 'large':
         return {
            fontSize: theme.fontSize.m,
            paddingTop: theme.spacing.m,
            paddingSides: theme.spacing.l
         }
      default:
         return {
            fontSize: theme.fontSize.sm,
            paddingTop: theme.spacing.m,
            paddingSides: theme.spacing.l
         }
   }
}

/**
 * Primary UI component for user interaction
 */
const BasicButton = styled.button`
   background: ${props =>
      props.disabled ? theme.color.disabledBg : theme.color.button};
   font-size: ${props => props.size.fontSize};
   border-radius: 4px;
   color: ${theme.color.white};
   padding: ${props => props.size.paddingTop}
      ${props => props.size.paddingSides};
   border: 0;
   cursor: ${props => (props.disabled ? 'cursor' : 'pointer')};
`

const PrimaryButton = styled(BasicButton)`
   background: ${theme.color.green};
   font-weight: bold;
`
export const Button = ({ isPrimary, size, label, isDisabled, ...props }) => {
   const sizeObjects = getButtonSizes(size)

   return isPrimary ? (
      <PrimaryButton
         type="button"
         disabled={isDisabled}
         size={sizeObjects}
         {...props}
      >
         {label}
      </PrimaryButton>
   ) : (
      <BasicButton
         disabled={isDisabled}
         type="button"
         size={sizeObjects}
         {...props}
      >
         {label}
      </BasicButton>
   )
}

Button.propTypes = {
   /**
    * Is this the principal call to action on the page?
    */
   isPrimary: PropTypes.bool,
   /**
    * How large should the button be?
    */
   size: PropTypes.oneOf(['small', 'medium', 'large']),
   /**
    * Button contents
    */
   label: PropTypes.string.isRequired,
   /**
    * Optional click handler
    */
   onClick: PropTypes.func
}

Button.defaultProps = {
   isPrimary: false,
   size: 'medium',
   label: 'Button',
   onClick: undefined
}
